import * as PIXI from 'pixi.js'
import {Signals} from "@/Imports";
import {TweenMax} from "gsap";

export default class TickerGenerator {
    constructor() {
        Signals.tickerStart.add(this.start.bind(this))
        Signals.tickerStop.add(this.stop.bind(this))

        // It was really freezy version
        // this.ticker = new PIXI.Ticker()

        this.ticker = TweenMax.ticker
        this.ticker.autoStart = true

        // this.ticker.add(time => {
        //     this.update()
        // })

        this.ticker.addEventListener('tick', () => this.update())
    }

    start() {
        this.ticker.start()
    }

    stop() {
        this.ticker.stop()
    }

    update () {
        Signals.tick.dispatch()
    }
}

new TickerGenerator()
